import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { showToast } from '@deeptrue-frontend/ui';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import Recommendations from './Recommendation/Recommendations';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.13);
  z-index: 100;
`;
const Content = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: scroll;
  padding: 1rem;
  background-color: #fafafa;
  flex-direction: column;
`;

const validationSchema = Yup.object().shape({
  recommendations: Yup.array().of(
    Yup.object().shape({
      title: Yup.object().shape({
        en: Yup.string().required('Required'),
        de: Yup.string().required('Required'),
        fr: Yup.string().required('Required'),
        it: Yup.string().required('Required'),
      }),
      shortDesc: Yup.object().shape({
        en: Yup.string().required('Required'),
        de: Yup.string().required('Required'),
        fr: Yup.string().required('Required'),
        it: Yup.string().required('Required'),
      }),
      longDesc: Yup.object().shape({
        en: Yup.string().required('Required'),
        de: Yup.string().required('Required'),
        fr: Yup.string().required('Required'),
        it: Yup.string().required('Required'),
      }),
      interpretations: Yup.array().of(
        Yup.object().shape({
          isRecommendation: Yup.boolean(),
          title: Yup.object().shape({
            en: Yup.string().required('Required'),
            de: Yup.string().required('Required'),
            fr: Yup.string().required('Required'),
            it: Yup.string().required('Required'),
          }),
          interpretationText: Yup.object().shape({
            en: Yup.string().required('Required'),
            de: Yup.string().required('Required'),
            fr: Yup.string().required('Required'),
            it: Yup.string().required('Required'),
          }),
          recommendationText: Yup.object().when('isRecommendation', {
            is: true,
            then: Yup.object().shape({
              en: Yup.string().required('Required'),
              de: Yup.string().required('Required'),
              fr: Yup.string().required('Required'),
              it: Yup.string().required('Required'),
            }),
          }),
        })
      ),
    })
  ),
});

interface Props {
  value: any;
  saveValue: any;
  editor: any;
}

const RecommendationCreator = ({ value, editor, saveValue }: Props) => {
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [values, setValues] = useState(value);

  const questionsList = Object.keys(editor.obj.questionHashes.names);

  const saveValues = (val: any) => {
    saveValue(val.recommendations);
    setValues(val.recommendations);
    showToast({ type: 'success', title: 'Saved' });
  };
  return (
    <div>
      <button onClick={() => setIsEditorOpen(true)}>Open Creator</button>
      {isEditorOpen && (
        <Wrapper>
          <Content>
            <Formik
              validationSchema={validationSchema}
              initialValues={{
                recommendations: values ? values : [],
              }}
              onSubmit={saveValues}
            >
              {({ handleSubmit, errors, touched, values }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <FieldArray name="recommendations">
                      {({ remove, push }) => {
                        return (
                          <Recommendations
                            values={values.recommendations}
                            push={push}
                            remove={remove}
                            setIsEditorOpen={setIsEditorOpen}
                            errors={errors.recommendations}
                            touched={touched.recommendations}
                            questionsList={questionsList}
                          />
                        );
                      }}
                    </FieldArray>
                  </Form>
                );
              }}
            </Formik>
          </Content>
        </Wrapper>
      )}
    </div>
  );
};

export default RecommendationCreator;
